import React, { useEffect, createElement } from 'react';
export const VideoPlayer = () => {
  useEffect(() => {
    // Load Wistia player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    // Load specific video embed script
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/22z21pljuf.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      // Cleanup scripts on unmount
      if (playerScript.parentNode) playerScript.parentNode.removeChild(playerScript);
      if (embedScript.parentNode) embedScript.parentNode.removeChild(embedScript);
    };
  }, []);
  return <div className="relative w-full max-w-5xl mx-auto rounded-lg overflow-hidden shadow-2xl" data-id="element-300">
      <style data-id="element-301">{`
        wistia-player[media-id='22z21pljuf']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/22z21pljuf/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 56.25%;
        }
      `}</style>
      {/* @ts-ignore - Wistia custom element */}
      <wistia-player media-id="22z21pljuf" aspect="1.7777777777777777" data-id="element-302"></wistia-player>
    </div>;
};